// Width ladders for promo srcset.
// Max widths match legacy imageResizer caps: 480 (vertical), 960 (horizontal).
export const PROMO_IMAGE_WIDTHS = {
  vertical: [240, 320, 400, 480],
  horizontal: [320, 480, 640, 960]
};

// Display slot ≈ player width on Video Leaf Pages:
// width 100% with maxWidth 360 (vertical) / 800 (horizontal).
export const PROMO_IMAGE_SIZES = {
  vertical: "(max-width: 360px) 100vw, 360px",
  horizontal: "(max-width: 800px) 100vw, 800px"
};
